import type React from 'react';

import { RenderTemplate } from '../components/RenderTemplate';

export const Layout: React.FC<EmptyProps> = () => {
	return <RenderTemplate />;
};
